import React from 'react';
import MainImage from '../mainImage/MainImage';
import ResumeUploadPage from './ResumeUploadPage';
import appStrings from '../../../../common/app_strings';
import { useAppState } from '../../../../providers/app-state/app-state-provider';

const { wholemeIntake: { resumeUpload } } = appStrings;

const ResumeStepIntakePage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
}) => {
  const { platform } = useAppState();

  return (
    <ResumeUploadPage
      paginationMeta={paginationMeta}
      nextOnClick={nextOnClick}
      prevOnClick={prevOnClick}
      wholeMeClient={wholeMeClient}
      title={resumeUpload.title}
      subtitle={resumeUpload.subtitle}
      backgroundOverlay="/assets/profile/wholeMe/resume/resume-upload-overlay.svg"
      categoryId="story"
      questionId="document"
      optionId="resume"
    >
      <MainImage
        imageSrc="/assets/profile/wholeMe/resume/resume-hero-img.svg"
        imageAlt="resume upload"
        imageStylesOverride={{
          paddingBottom: '-20px',
          width: platform?.isNativePlatform ? '100%' : 'calc(45% - 70px)',
        }}
      />
    </ResumeUploadPage>
  );
};

export default ResumeStepIntakePage;
